import {createSlice} from '@reduxjs/toolkit';

const initialState = {
    isLoggedIn: !!localStorage.getItem("jwtToken"),
    user: null,
};

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        login: (state, action) => {
            const {token, user} = action.payload;
            state.isLoggedIn = true;
            state.user = user;
            localStorage.setItem("jwtToken", token);
        },
        logout: (state) => {
            state.isLoggedIn = false;
            state.user = null;
            localStorage.removeItem("jwtToken");
        },
    },
});

export const {login, logout} = authSlice.actions;
export default authSlice.reducer;
